export default "__VITE_ASSET__Dscz4CUQ__"